import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDebouncedCallback } from 'use-debounce';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;

  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    width: 34vw;
    max-width: 461px;
  `)}
`;

const SearchInput = styled.input`
  border: 0;
  border-bottom: 1px solid ${props => props.theme.secondaryColorLight};
  font-size: ${props => (props.theme.isMobile ? '15px' : '11px')};
  font-weight: ${props => props.theme.fontWeightHeavy};
  color: ${props => props.theme.bodyColor};
  padding: 0 0 2px 25px;
  outline: none;

  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    width: 32vw;
  `)}

  &::placeholder {
    color: ${props => props.theme.secondaryColor};
  }
`;

const SearchIcon = styled.span`
  position: relative;
  margin-right: -15px;
  color: ${props => props.theme.secondaryColor};
  font-size: ${props => (props.theme.isMobile ? '15px' : '11px')};
  margin-left: 3px;
`;

export default function SearchProductsControl({ onSearch }) {
  const { callback: debounced } = useDebouncedCallback(v => onSearch(v), 300);

  const onChange = e => {
    e.persist();
    e.preventDefault();

    debounced(e.target.value);
  };

  return (
    <Container>
      <SearchIcon className="icon-lw icon-lw-magnifying-glass" />
      <SearchInput placeholder="Search for stock codes, ETFs or LICs" onChange={onChange} />
    </Container>
  );
}

SearchProductsControl.propTypes = {
  onSearch: PropTypes.func.isRequired,
};
